import { InputAdornment, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SearchNormal1 } from "iconsax-react";
import { memo } from "react";

import type { SearchFieldProps } from "./SearchField.types";
import * as styles from "./SearchField.styles";

export type { SearchFieldProps } from "./SearchField.types";

export const SearchField = memo(function SearchField({
  fieldSize = "default",
  placeholder,
  slotProps,
  ...textFieldProps
}: SearchFieldProps) {
  const theme = useTheme();

  return (
    <TextField
      variant="outlined"
      fullWidth
      placeholder={placeholder}
      sx={styles.root}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          sx: styles.inputRoot(fieldSize),
          endAdornment: (
            <InputAdornment position="end" sx={styles.adornment}>
              <SearchNormal1
                size={20}
                variant="Linear"
                color={theme.palette.primary.contrastText}
              />
            </InputAdornment>
          ),
        },
      }}
      {...textFieldProps}
    />
  );
});
